export const LOGIN_USER = 'parcel/login/LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'parcel/login/LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'parcel/login/LOGIN_USER_ERROR';

export const IMPORT_SAFE = 'parcel/login/IMPORT_SAFE';
export const OPEN_SAFE = 'parcel/login/OPEN_SAFE';
export const SWITCH_SAFE = 'parcel/login/SWITCH_SAFE';
